import { MutationTree } from 'vuex';
import { PushDevicesState } from './types';

export const mutations: MutationTree<PushDevicesState> = {
    pushDevices:(state, data) => {
        state.pushDevices = state.pushDevices.concat(data)
    },
    setDevices:(state, data) => {
        state.pushDevices = data
    },
    setDeviceItem:(state, data) => {
        state.pushDeviceItem = data
    },
    setMappsVersions:(state, data) => {
        state.pushMappsVersions = data
    },
    setSdkVersions:(state, data) => {
        state.pushSdkVersions = data
    },
    setOsVersions:(state, data) => {
        state.pushOsVersions = data
    },
};
